<template>
  <b-modal v-model="visible" :title="title" @ok="onOk" @show="onShow">
    <b-form @submit.prevent="onSubmit">
      <b-form-group class="required" label="Data zakończenia cyklu">
        <date-picker
          :class="{'is-invalid': $v.endDate.$error}"
          v-model="endDate"
          :config="dateTimeOptions"
          autocomplete="off"
          language="pl"
        />
        <div class="invalid-feedback" v-if="!$v.endDate.required">To pole jest wymagane</div>
        <div
          class="invalid-feedback"
          v-if="!$v.endDate.minValue"
        >Makrocykl nie może się kończyć wcześniej niż {{cycle.minEndDate | date}}</div>
      </b-form-group>
    </b-form>
  </b-modal>
</template>

<script>
// import { axios, eventBus } from "@/_infrastructure";
import { required } from "vuelidate/lib/validators";
import moment from "moment";

const minValue = function(value) {
  return !value || value >= moment(this.cycle.minEndDate).format("YYYY-MM-DD");
};

export default {
  data() {
    return {
      title: "Edycja makrocyklu",
      visible: false,
      cycle: null,
      endDate: null,
      dateTimeOptions: {
        format: "YYYY-MM-DD",
        minDate: null,
        locale: "pl",
      }
    };
  },
  filters: {
    date(date) {
      return date ? moment(date).format("YYYY-MM-DD") : "-";
    }
  },
  validations: {
    endDate: { required, minValue }
  },
  methods: {
    moment() {
      return moment();
    },
    show(cycle) {
      this.visible = true;
      this.cycle = cycle;

      this.endDate = cycle.endDate;
      this.dateTimeOptions.minDate = cycle.minEndDate;
    },
    onShow() {
      this.$v.$reset();
    },
    onOk(e) {
      e.preventDefault();
      this.onSubmit();
    },

    onSubmit() {
      this.$v.$touch();

      var r = {
        cycleId: this.cycle.id,
        endDate: this.endDate
      };

      if (!this.$v.$error) {
        this.$emit("save", r);
        this.visible = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
</style>

